import { render, staticRenderFns } from "./ProductDashboard.vue?vue&type=template&id=3ac39680&scoped=true"
import script from "./ProductDashboard.vue?vue&type=script&lang=js"
export * from "./ProductDashboard.vue?vue&type=script&lang=js"
import style0 from "./ProductDashboard.vue?vue&type=style&index=0&id=3ac39680&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac39680",
  null
  
)

export default component.exports